import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Reflux from 'reflux';

import * as constants from '../constants';
import Property from './property';
import stateStore from '../stores/state-store';

const CLASS_NAME = 'slx-product-wizard-facet';

export default createReactClass({
	displayName: 'ProductWizardFacet',

	propTypes: {
		facet: PropTypes.object.isRequired,
		onSelectProperty: PropTypes.func.isRequired,
		loadingProperty: PropTypes.object,
		showPreselectionItemCount: PropTypes.bool,
		inline: PropTypes.bool,
		isAccessory: PropTypes.bool
	},

	mixins: [
		Reflux.listenTo(stateStore, 'onWindowChange', 'onWindowChange'),
	],

	getInitialState() {
		return {
			isCollapsed: true,
			width: 0
		};
	},

	getDefaultProps() {
		return {
			inline: false
		};
	},

	componentWillReceiveProps(nextProps) {
		if (nextProps.facet.selectedProperty) {
			this.setState({isCollapsed: true});
		}
	},

	onExpand() {
		this.setState({isCollapsed: false});
	},

	onWindowChange(data) {
		this.setState({width: data.propWidth});
	},

	onSelectProperty(facet, property) {
		this.props.onSelectProperty(facet, property);
	},

	render() {
		const facet = this.props.facet;
		const hasQuasiSelectedProperty = !facet.selectedProperty && facet.quasiSelectedProperty;
		const canCollapse = !facet.isPreselecting && facet.properties.length >= constants.MINIMUM_NUMBER_OF_PROPERTIES_TO_COLLAPSE;
		const isCollapsed = canCollapse && this.state.isCollapsed;
		const isSelectable = facet.selectedProperty || hasQuasiSelectedProperty || facet.selectableProperties.length !== 0;

		let label = (facet.description !== '') ? facet.description : facet.label;
		if (label) label = label.replace(/(\w+)- (\w+)/g, '$1$2'); // remove eventual hyphens

		const properties = facet.properties
			.sort((a, b) => a.sort - b.sort)
			.map((property) => {
				property.isCollapsed =					(facet.isReduced && property.isDisabled)
					|| (isCollapsed && !property.isSelected);
				return property;
			});

		const expandButtonClasses = `slx-product-wizard-label multiple${
			!isCollapsed ? ' collapsed' : ''
		}${!isSelectable ? ' disabled' : ''}`;
		const expandButtonFirst = canCollapse && properties[0].label || null;
		const expandButtonLast = canCollapse && properties[properties.length - 1].label || null;

		const expandButton = (
			<li
				className={expandButtonClasses}
				onClick={this.onExpand}
			>
				{expandButtonFirst}{' … '}{expandButtonLast}
				<br />
				<i>alle anzeigen</i>
			</li>
		);

		const classes = `${CLASS_NAME} ${
			facet.selectedProperty ? `${CLASS_NAME}--selected ` : ' '
		}${hasQuasiSelectedProperty ? `${CLASS_NAME}--quasi-selected ` : ' '
		}${!isSelectable ? `${CLASS_NAME}--unselectable ` : ' '}`;

		let header = (
			<header className={`${CLASS_NAME}__head`}>
				{label}
			</header>
		);

		let facetWidth = this.state.width ? {width: this.state.width} : {};
		let propWidth = null;

		if (this.props.inline) {
			facetWidth = {};
			propWidth = this.state.width;
		}

		return (
			<article className={classes} data-slider-slide style={facetWidth}>
				{header}

				<ul className={`${CLASS_NAME}__labels`}>
					{properties.map(property => (
						<Property
							facet={facet}
							property={property}
							key={property.id}
							onSelectProperty={this.onSelectProperty}
							showPreselectionItemCount={this.props.showPreselectionItemCount}
							width={propWidth}
							isAccessory={this.props.isAccessory}
							isLoading={this.props.loadingProperty && (this.props.loadingProperty.id === property.id)}
							highlight={property.highlight}
							modificators={property.modificators}
						/>
					))}
					{expandButton}
				</ul>
			</article>
		);
	}
});
